import { ConnectionDto, mapConnectionUIName } from "@arelia-types/connection"
import ConnectionCard from "./ConnectionCard";
import { useState } from "react";
import BasicDialog from "../dialogs/BasicDialog";
import { Box, Typography } from "@mui/material";
import { useAvailableServiceAccounts } from "../../../../api/availableServiceAccounts";

type Props = {
  connection: ConnectionDto,
}

export default function AuthServiceConnection({ connection }: Props) {
  const [open, setOpen] = useState<boolean>(false);
  const pagesQuery = useAvailableServiceAccounts(connection.name, { enabled: true });

  return <Box>
    <ConnectionCard {...connection} onConnect={() => setOpen(true)} />
    {open && <BasicDialog
      connection={connection}
      title={`${connection.name} connection`}
      onClose={() => setOpen(false)}
      pagesQuery={pagesQuery}
      showSaveButton={pagesQuery.data && pagesQuery.data.length > 0}
    >
      {
        !connection.connected
          ?
          <Typography>
            Arelia is not connected to {mapConnectionUIName(connection.name)} yet.
            Please authenticate to {mapConnectionUIName(connection.name)} using Arelia Authenticator app.
          </Typography>
          :
          <Typography>Arelia has successfully connected to {mapConnectionUIName(connection.name)}{connection.login ? <> with account <b>{connection.login}</b></> : ''}.
          </Typography>
      }
    </BasicDialog>}
  </Box>;
}